import '../ebol_matching.css'
import { EbolDrawerBase } from './Drawer/EbolDrawerBase'
import { EbolDrawerTitle } from './Drawer/EbolDrawerTitle'
import { EbolDrawerFooter } from './Drawer/EbolDrawerFooter'
import { EbolDrawerContent } from './Drawer/EbolDrawerContent'

export const EbolDrawer = () => (
  <EbolDrawerBase title={<EbolDrawerTitle />} footer={<EbolDrawerFooter />}>
    <EbolDrawerContent />
  </EbolDrawerBase>
)
